
.ds-grid {
  &__row {
    display: flex;
    flex-wrap: wrap;
  }
  &.--fixed {
    & .ds-grid {
      &__row {
      }
    }
  }
  
  &.--fluid {
    & .ds-grid {
      &__row {
      }
    }
  }

  &.--align-start {
    & .ds-grid {
      &__row {
        justify-content: flex-start;
      }
    }
  }

  &.--align-center {
    & .ds-grid {
      &__row {
        justify-content: center;
      }
    }
  }
  
  &.--align-end {
    & .ds-grid {
      &__row {
        justify-content: flex-end;
      }
    }
  }

  &.--v-align-start {
    & .ds-grid {
      &__row {
        align-items: flex-start;
      }
    }
  }

  &.--v-align-center {
    & .ds-grid {
      &__row {
        align-items: center;
      }
    }
  }

  &.--v-align-end {
    & .ds-grid {
      &__row {
        align-items: flex-end;
      }
    }
  }
}